import { FC, useState } from "react";

import { Button, Modal } from "antd";

import { CaseForm } from "components/common";
import { useAppDispatch, useAppSelector } from "store";
import { getCasesSelector } from "store/cases/cases.selector";
import { setCaseModal } from "store/cases/cases.actions";
import { ContractorForm } from "components/contractors";

import "./CreateCaseModal.scss";

interface IProps {
  size?: "small" | "middle" | "large" | undefined;
  serial_number?: string;
  id?: number;
  block?: boolean;
}

const CreateCaseModal: FC<IProps> = ({
  size = "middle",
  block,
}) => {
  const dispatch = useAppDispatch();
  const { modal } = useAppSelector(getCasesSelector);
  const [ isContractorModalOpen, setContractorModalOpen ] = useState(false);

  return (
    <>
      <Button
        block={ block }
        type="primary"
        size={ size }
        onClick={ () => dispatch(setCaseModal({
          ...modal,
          isOpen: true,
        })) }
      >
        Open case
      </Button>

      {modal?.isOpen && (
        <Modal
          className="create-case-form"
          open={ !!modal?.isOpen }
          onCancel={ () => dispatch(setCaseModal({
            ...modal,
            isOpen: false,
          })) }
          footer={ null }
        >
          <CaseForm
            afterEvent={ () => dispatch(setCaseModal({
              ...modal,
              isOpen: false,
            })) }
            id={ modal.id }
            serial_number={ modal.serial_number }
            setContractorModalOpen={ () => setContractorModalOpen(true) }
          />

          <Modal
            open={ isContractorModalOpen }
            onCancel={ () => setContractorModalOpen(false) }
            footer={ null }
            width={ 500 }
            title="Add contractor"
          >
            <div style={ { padding: 20 } }>
              <ContractorForm onClose={ () => setContractorModalOpen(false) } />
            </div>
          </Modal>
        </Modal>
      )}
    </>
  )
}

export default CreateCaseModal;
